if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const currencyRate = window.Shopify?.currency?.rate ? Number(window.Shopify.currency.rate) : 1;
      const convertedThreshold = Math.round(freeShippingThreshold * currencyRate);
      const freeShippingRemaining = convertedThreshold - cartTotal;
      const country = this.getAttribute('data-country') || '';
      const shippingSuccess = freeShippingRemaining <= 0;
      const progress = convertedThreshold > 0 ? Math.min(100, Math.max(0, cartTotal / convertedThreshold * 100)) : 0;
      const messageTemplate = shippingSuccess ? this.getAttribute('data-message-eligible') : this.getAttribute('data-message-remaining');
      const shippingMessage = this._interpolate(messageTemplate, {
        country,
        remaining_amount: this._formatMoney(Math.max(0, freeShippingRemaining), KROWN.settings.shop_money_format)
      });
      const thresholdMessage = this._interpolate(this.getAttribute('data-threshold-message'), {
        threshold: this._formatMoney(convertedThreshold, KROWN.settings.shop_money_format)
      });
      const messageElement = this.querySelector('[data-shipping-progress-message]');
      const progressElement = this.querySelector('[data-shipping-progress-bar]');
      const progressFill = this.querySelector('[data-shipping-progress-fill]');
      const thresholdElement = this.querySelector('[data-shipping-progress-threshold]');

      if ( messageElement ) {
        messageElement.textContent = shippingMessage;
      }
      if ( progressElement ) {
        progressElement.setAttribute('aria-valuenow', Math.round(progress).toString());
      }
      if ( progressFill ) {
        progressFill.style.width = `${progress}%`;
      }
      if ( thresholdElement ) {
        thresholdElement.textContent = thresholdMessage;
      }

      this.classList.toggle('cart-shipping-progress__notice--success', shippingSuccess);

    }

    _interpolate(template, values) {
      let output = template || '';
      Object.entries(values).forEach(([key, value]) => {
        output = output.replaceAll(`{{ ${key} }}`, value).replaceAll(`{{${key}}}`, value);
      });
      return output;
    }

    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
